import React from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { SidebarActionButtonProps } from './types';
import { styles } from './styles';

export const SidebarActionButton: React.FC<SidebarActionButtonProps> = ({
  icon,
  label,
  collapsed,
  onClick,
  variant = 'default',
  badge,
}) => {
  const handleKeyDown = (e: React.KeyboardEvent): void => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  const hasBadge = badge != null && badge > 0;
  const itemClass = variant === 'danger' ? styles.footerItemDanger : styles.footerItem;

  return (
    <div
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      className={itemClass}>
      <span className={styles.footerIconWrapper}>
        <FontAwesomeIcon icon={icon} className={styles.footerIcon} />
        {hasBadge && collapsed && <span className={styles.badge}>{badge}</span>}
      </span>
      <span
        className={clsx(
          styles.navLabel,
          collapsed ? styles.navLabelHidden : styles.navLabelVisible,
        )}>
        {label}
        {hasBadge && <span className={styles.badgeInline}>{badge}</span>}
      </span>
      {collapsed && (
        <span className={styles.tooltip}>
          {label}
          {hasBadge ? ` (${badge})` : ''}
        </span>
      )}
    </div>
  );
};

export default SidebarActionButton;
